import React from "react";
import "./SupportGrid.css";

const BASE = process.env.PUBLIC_URL || "landing-page";

const items = [
  { title: "خطط علاجية",  text: "خارطة طريق تناسب أهدافك الشخصية.",            icon: `${BASE}/assets/heartplusIcon.png` },
  { title: "تمارين عملية", text: "خطوات صغيرة تغيّر الكثير على المدى الطويل.",   icon: `${BASE}/assets/ideaIcon.png` },
  { title: "ملفات تفاعلية", text: "محتوى قابل للتطبيق المباشر على يومك.",        icon: `${BASE}/assets/galleryIcon.png` },
  { title: "سرّية وأمان",  text: "خصوصيتك أولويتنا دائمًا.",                     icon: `${BASE}/assets/securityIcon.png` },
  { title: "متابعة ذكية",  text: "مؤشرات وتذكيرات تراعي وتيرتك.",                icon: `${BASE}/assets/followingIcon.png` },
  { title: "تحديات يومية",  text: "عادات بسيطة تُبنى باستمرار.",                  icon: `${BASE}/assets/targetIcon.png` },
];

export default function SupportGrid() {
  return (
    <section className="support container" dir="ltr">
      <h2 className="support__title">
        أكثر من <span className="support__accent">استشارة</span>.. دعم عملي مستمر
      </h2>

      <div className="support__grid">
        {items.map((it, i) => (
          <article className="sg-card" key={i} tabIndex="0" aria-label={it.title}>
            <div className="sg-card__head">
              <img
                className="sg-card__icon"
                src={it.icon}
                alt=""
                aria-hidden="true"
                loading="lazy"
                decoding="async"
              />
              <h3 className="sg-card__title">{it.title}</h3>
            </div>
            <p className="sg-card__text">{it.text}</p>
          </article>
        ))}
      </div>

      {/* ===== Banner ===== */}
      <section className="banner" aria-hidden="true">
        <div className="banner__top-images">
          <img
            className="king"
            src={`${BASE}/assets/king.png`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
          />
          <img
            className="mermaid"
            src={`${BASE}/assets/mermaid.png`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="banner__frame">
          <img
            className="banner__img"
            src={`${BASE}/assets/supportBanner.png`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
            sizes="(max-width: 1024px) 100vw, 1300px"
          />
        </div>
      </section>
    </section>
  );
}
